<template>
	<div class="margin-left">
		<div class="time-picker text-left">
			<el-date-picker v-model="month" type="month" clear-icon="el-icon-circle-close" placeholder="选择月" @change="chose">
			</el-date-picker>
		</div>
		<div class="bg-white list margin-top">
			<div v-if="total != 0">
				<div class="padding" v-for="(item,index) in listData" :key="index">
					<div class="flex align-center justify-between">
						<div class="flex flex-direction align-start justify-between">
							<p class="text-df text-333">申请提现{{item.price}}元</p>
							<p class="margin-top-sm text-sm text-ccc">{{item.create_time}}</p>
						</div>
						<!-- <p>平台审核通过</p> -->
						<p v-if="item.status == 1" class="fu-fs26 text-333">平台审核中</p>
						<p v-if="item.status == 2" class="fu-fs26 text-333">平台审核通过</p>
						<p v-if="item.status == 3" class="fu-fs26 text-prices">审核暂未通过</p>
					</div>
					<p v-if="item.status == 3" class="text-left margin-top-sm text-df text-999">原因：{{item.reason}}</p>
				</div>
			</div>
			<div class="text-center" v-else>
				<el-empty description="暂无数据"></el-empty>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				month: '',//选择的月份
				page:1,
				total:0,//
				listData:[]
			};
		},
		created(){
			this.getlist()
		},
		methods:{
			/**
			 * 选择月
			 * */
			chose(){
				
			},
			handleCurrentChange: function(currentPage) {
			  this.page = currentPage;
			  this.getlist();
			},
			/**
			 * 获取列表
			 * TODO  分页以及时间筛选
			 * */
			getlist(){
				this.ajax('get', '/api/pc/withdrawal/getLogList',{
					page:this.page,
					time:'',
				}, res => {
					console.log(res);
					if (res.status == 200) {
						this.listData = res.data.data
						this.lastpage = res.data.lastpage
						if(this.page == 1){
							this.total =  Number(res.data.lastpage) * Number(res.data.data.length)
						}
						
					} else {
						this.$message(res.msg);
					}
				})
			}
		}
	};
</script>

<style scoped lang="less">
	.time-picker {
		width: 920px;
		height: 80px;
		background: #FFFFFF;
		border-radius: 8px;
	}

	/deep/ .el-input__inner {
		border: 0;
		height: 80px !important;
		font-size: 18px;
	}
	.list{
		width: 921px;
		box-shadow: 0px 2px 51px 0px rgba(34,34,34,0.08);
		border-radius: 20px;
	}
</style>



// WEBPACK FOOTER //
// src/components/my/wallet/record.vue